const en = {
  commonTitle: '澳門科技大學校友會聯合總會',
  library: {
    useGuide: '澳門科技大學圖書館校友使用指引',
    bodyContent: {
      itemOne: {
        title: '第一條 主旨',
        contentOne: '為鼓勵澳門科技大學校友會聯合總會(以下簡稱校友總會)之會員持續成長，終身學習，共享母校資源，特訂定「澳門科技大學圖書館校友使用指引」。'
      },
      itemTwo: {
        title: '第二條 入館閱覽資格',
        contentOne: '1.可直接憑由校友總會發出的有效電子校友卡(限本人使用)進館。',
        contentTwo: '2.開通WeMust賬戶及其電子錢包功能後，校友將自動具有圖書館校友服務的權限。',
        contentThree: '左圖為電子校友卡樣式(可透過WeMust或澳門科技大學校友會聯合總會微信公眾號平台上登記註冊)'
      },
      itemThree: {
        title: '第三條 圖書館校友服務：',
        contentOne: {
          contentTitle: '1.借閱服務',
          guideOne: '持有效電子校友卡或通過WeMust手機掃碼借書功能進行圖書外借；',
          guideTwo: '每賬戶最多可外借圖書三冊；',
          guideThree: '可通過WeMust圖書館應用進行圖書預約，或續借。',
          scanGuide: '手機掃碼借書指引',
          videoGuide: '手機掃碼借書教學視頻'
        },
        contentTwo: {
          contentTitle: '2.電子資源服務',
          guideOne: '電子資源只限館內電腦使用；',
          guideTwo: '持有效電子校友卡的校友，可到圖書館流通服務台領取館內使用電子資源的臨時賬戶。'
        },
        contentThree: {
          contentTitle: '3.參考諮詢服務',
          guideOne: '參考館員可為您解答有關圖書館資源與服務的疑問。',
          guideTwo: '服務時間：週一至週五：上午10:30~13:30；下午15:00~18:00；週末，公眾假日及寒暑假期間暫停服務。',
          guideThree: '聯繫電郵：library_ref@must.edu.mo',
          guideFour: '聯絡電話：(+853) 8897 2326; 8897 2843。'
        },
        contentFour: {
          contentTitle: '4.文獻傳遞服務',
          guideOne: '在遵守版權和知識產權的前提下，校友可向本館申請獲取所需文獻資料的全文；',
          guideTwo: '請將所需全文資料的題錄資訊(如作者、題名等來源資料)通過電郵library_ref@must.edu.mo提交申請；',
          guideThree: '圖書館將在3個工作日內將全文通過電郵傳遞給申請人，如無法獲取全文亦將說明。'
        },
        contentFive: {
          contentTitle: '5.自助列印、影印、掃描服務',
          guideOne: '校友可使用電子校友卡（開通WeMust錢包）或澳門通咭（咭內餘額不少于MOP10）進行自助列印、影印或掃描。'
        }
      },
      itemFour: {
        title: '第四條 其他注意事項',
        contentOne: '1.校友在使用電子校友卡或校友借書證時必須遵守所有出入校園管制措施/限制。',
        contentTwo: '2.圖書館實行一證制，即使校友擁有多於一個身份，圖書館只會按校友建議選用其中一個身份作為有效讀者賬戶。',
        contentThree: '3.校友應同意並遵守澳門科技大學圖書館所訂定的規章。',
        contentFour: '4.澳門科技大學校友會聯合總會及澳門科技大學圖書館可對任何不通過審核的申請保留權利。',
        contentFive: '5.澳門科技大學校友會聯合總會及澳門科技大學圖書館保留隨時修改規章的權利。'
      }
    }
  },
  wifi: {
    tabTitle: {
      ios: 'iOS版',
      android: 'Android版'
    },
    ios: {
      useGuide: 'iOS系統連接Wi-Fi, MUST-Guest 步驟',
      titleOne: '1. 打開 設置 > Wi-Fi，選擇 MUST-Guest。',
      titleTwo: '2. 彈出下方畫面後，在 “我接受用戶條款” 的方格中打勾，然後按 “登陸”。',
      titleThree: '3. 如彈出以下畫面，點選 “繼續”。',
      titleFour: '4. 彈出以下畫面及出現 Wi-Fi 圖標，即代表 Wi-Fi 連接成功。'
    },
    android: {
      useGuide: 'Android 系統連接 Wi-Fi, MUST-Guest 步驟',
      titleOne: '1. 打開 設置 > Wi-Fi，選擇 MUST-Guest。',
      titleTwo: '2. 如果沒有彈出登入畫面，請點選“登入 Wi-Fi 網路”的通知。',
      titleThree: '3. 彈出下方登入畫後，在“我接受用戶條款”的方格中打勾，然後按“登陸”。',
      titleFour: '4. 彈出以下畫面及出現 Wi-Fi 圖標，即代表 Wi-Fi 連接成功。'
    }
  }
};
export default en;



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js